import { render } from "./PropertiesView.vue?vue&type=template&id=a0f9289a"
import script from "./PropertiesView.vue?vue&type=script&lang=js"
export * from "./PropertiesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__